module.exports = __webpack_public_path__ + "static/media/assessment-mac-img.f6e6503a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-it-works-assessment/assessment-mac-img.png
// module id = 383
// module chunks = 0